import { getGoAddress } from '../../utils/PageAddressUtil';

export default function BlogCardFooter({ statusOk, submittedInfo, submittedInfoTip, address }) {
    return (
        <div className="redesign-blog-card-footer">
            <span className={`redesign-status-dot${statusOk ? '' : ' error'}`} title={statusOk ? '该博客运行状态良好' : '该博客目前无法访问'}>
                {statusOk ? '运行良好' : '无法访问'}
            </span>
            <a className="redesign-visit-link" href={getGoAddress(address)} target="_blank" rel="noopener noreferrer">
                访问博客 →
            </a>
        </div>
    );
}
